// extracted by mini-css-extract-plugin
module.exports = {"container":"LivingSituation_container__uPOZQ"};